export default "__VITE_ASSET__1af30776__"